var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.792893 0.793044C1.18342 0.40252 1.81658 0.40252 2.20711 0.793044L9.20711 7.79304C9.59763 8.18357 9.59763 8.81673 9.20711 9.20726C8.81658 9.59778 8.18342 9.59778 7.79289 9.20726L0.792893 2.20726C0.402369 1.81673 0.402369 1.18357 0.792893 0.793044Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90 5 5)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.792893 0.793044C1.18342 0.40252 1.81658 0.40252 2.20711 0.793044L9.20711 7.79304C9.59763 8.18357 9.59763 8.81673 9.20711 9.20726C8.81658 9.59778 8.18342 9.59778 7.79289 9.20726L0.792893 2.20726C0.402369 1.81673 0.402369 1.18357 0.792893 0.793044Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.a539eaae847baa6e9cdd190b6059ca28.svg";
export { ForwardRef as ReactComponent };